import { AttachmentType } from '@shared/components/text-attachments-input/enums/text-attachment-type.enum';

export const getFileType = (file: File) => {
  if (file.type.indexOf('image') !== -1) {
    return AttachmentType.PHOTO;
  } else {
    return AttachmentType.FILE;
  }
};
